import { useTranslation } from 'react-i18next';

import { useDeviceDetails } from '@apis/asset-data-service/queries/use-device-details';
import { DateTime } from '@packages/components/date-time/date-time';
import { EMPTY_FIELD_FALLBACK } from 'ae-constants/constants';

import { AssetInformationFieldWrapper } from './asset-information-field-wrapper/asset-information-field-wrapper';

interface AssetInformationLastSeenProps {
  assetId: string;
}

export const AssetInformationLastSeen = ({
  assetId,
}: AssetInformationLastSeenProps) => {
  const { t } = useTranslation('ads', {
    keyPrefix: 'fields',
  });
  const { data: device } = useDeviceDetails(assetId);
  const { lastSeenTime } = device ?? {};

  return (
    <AssetInformationFieldWrapper
      assetId={assetId}
      term={t('lastSeen')}
      skeletonProps={{ width: '9rem' }}
    >
      <DateTime value={lastSeenTime} placeholder={EMPTY_FIELD_FALLBACK} />
    </AssetInformationFieldWrapper>
  );
};
